import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { Link } from 'gatsby';
import './design-guidelines-styles.css';
import { DemoModal } from '../../components/DemoModal';
import { DocsHeading } from '../../components/DocsHeading';
import { LeadParagraph } from '../../components/LeadParagraph';
import { Button, Modal } from 'react-magma-dom';
export const _frontmatter = {
  "pageTitle": "Modal Design Guidelines",
  "title": "Modal",
  "order": 1
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

<DocsHeading to="/api/modal/" type="design" mdxType="DocsHeading">
  Modal
</DocsHeading>
<LeadParagraph mdxType="LeadParagraph">
  Modals inform users about a task and can contain critical information, require
  decisions, or involve multiple tasks.
</LeadParagraph>
<p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.61776061776062%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAIAAADtbgqsAAAACXBIWXMAAAsTAAALEwEAmpwYAAABSUlEQVQoz32Sy26CQBSGfU7YGRRJ6IZFozxBE7bY4qohQV+gG1/AdRctaRpgKYSES4uAQLn0lwnWKOVLmJy5/Oecf5jRtGUymfA8L4riYrGYz+f3/yMIwrRjhG82m9E0rapqmqa2bR8Oh7IsfzrKDsRN0+i6jkp/Yo7jKIpar9d1Xfu+H8fx8XjMsgwj0mGaJAliJK2qyrIshmGuxZqmQWC3OI6z3+8xIvY877slCAIcMAyjX4yuSG+oULc0F5BpT2V4hhi9ua6L8coqoSgKiIcqwx56O4tvL8w0zX4xtmEM56oW9Ilc8JznOaZYHxJjLwxDCNAh6RMWcFWnlTyvq+rkeUBM0tcdJCa5nK/YjrL3j8/p7X/ebDZn8SVwHUURKj9s3+jn3cvu9Y5jmVZ/ErMsOx6P8TAVRZFleXnDE+FxuVopkiSdX9gvA6sIlIPZFcIAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": " ",
          "title": " ",
          "src": "/version/2.6.2/static/9891395ff40cc51d3a5528272e3dd799/e3189/modal-example-intro.png",
          "srcSet": ["/version/2.6.2/static/9891395ff40cc51d3a5528272e3dd799/a2ead/modal-example-intro.png 259w", "/version/2.6.2/static/9891395ff40cc51d3a5528272e3dd799/6b9fd/modal-example-intro.png 518w", "/version/2.6.2/static/9891395ff40cc51d3a5528272e3dd799/e3189/modal-example-intro.png 1035w", "/version/2.6.2/static/9891395ff40cc51d3a5528272e3dd799/44d59/modal-example-intro.png 1553w", "/version/2.6.2/static/9891395ff40cc51d3a5528272e3dd799/913b9/modal-example-intro.png 1822w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
<hr></hr>
<h2>{`Principles`}</h2>
<h3>{`Focused`}</h3>
<p>{`Modals focus user attention to ensure their content is addressed.`}</p>
<h3>{`Direct`}</h3>
<p>{`Modals should be direct in communicating information and dedicated to completing a task.`}</p>
<h3>{`Helpful`}</h3>
<p>{`Modals should appear in response to a user task or an action, with relevant or contextual information.`}</p>
<hr></hr>
<h2>{`Usage`}</h2>
<p>{`A modal is intentionally interruptive and blocks the user from interacting with the on-page content. Modals keep the user focused on the task or information until they either cancel or complete the task. Modals can be very useful when used effectively but should be used sparingly to avoid disrupting the user too much. Here are some guidelines for when to use a modal.`}</p>
<h3>{`Confirm a User Decision`}</h3>
<p>{`Clearly describe the decision being made by the user, and explain any possible consequences it could cause. The primary button should also reinforce the action being taken. If the action being taken is irreversible, make that clear to the user as well. The user should also be able to cancel the action with a secondary button or closing the modal.`}</p>
<span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1035px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "52.123552123552116%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA4klEQVQoz2NIQwUpKSn5+fnTp0+fOXPmDDAAsmfNmlVTU5OUlJSeno6smAGZA5RLSEhoa2v79u3bly9fPn/+/OvXr79///7//3/t2rVRUVGZmZkENLe0tLx79+4VDDx5+uzXr9/Eam5tbX0LBj9+/Pj+/fuf3z+ANq9Zs4ZYzUCn/vv379ePHx++/cxbfrxr3+2Vq9ZER0dnZGTg0wwMldra2tu3b9+6devypUsXr1yduG7v4r2nZ82eExsbi08zmkFApRnpacV52UW5WVjVMODSCY2V9PSU1DQgIkEzkYAizQCVbSWFOEhAlwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": " ",
        "title": " ",
        "src": "/version/2.6.2/static/b6a4f5f24b350455f1bb57485f87e4a9/e3189/confirm-decision.png",
        "srcSet": ["/version/2.6.2/static/b6a4f5f24b350455f1bb57485f87e4a9/a2ead/confirm-decision.png 259w", "/version/2.6.2/static/b6a4f5f24b350455f1bb57485f87e4a9/6b9fd/confirm-decision.png 518w", "/version/2.6.2/static/b6a4f5f24b350455f1bb57485f87e4a9/e3189/confirm-decision.png 1035w", "/version/2.6.2/static/b6a4f5f24b350455f1bb57485f87e4a9/44d59/confirm-decision.png 1553w", "/version/2.6.2/static/b6a4f5f24b350455f1bb57485f87e4a9/913b9/confirm-decision.png 1822w"],
        "sizes": "(max-width: 1035px) 100vw, 1035px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
<h3>{`Edit or Manage Tasks`}</h3>
<p>{`It's very common to use a modal to quickly edit or manage one or more items on a page without going back and forth between multiple pages. The emphasis here is "quickly". If the settings or management of an item becomes relatively complex and requires many decisions or multiple steps, please consider using a separate page or something other than a modal. If a particular action is often done repeatedly, consider allowing the action to be done directly on the main page rather than in a modal.`}</p>
<span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1035px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "66.79536679536679%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABQElEQVQoz4WSu2qEUBCGfcygnXhNkQcQ30AIlpo1AVHs06fc9Esgm40XsAlsIbqLrvdLJh7iEvWQH7Q4M9+Zf+YMwXEcz/M0TUuSZBiGpmm6rmsYQUhRFO5XBHyiKJIk6TjOMAxJkpRlOayp73v4h2HIMMwVFgSBoijLspqmiaKorutuTW3bAhwEwR8YKiMYYkVRtBjB1ZDguu4cBtu2bUNGHMc4GBz9UznLsg4jZNvzPCwMSQNGaGBY2xCrqmry2Y/VrrbHnn3fX68MdwM8mSyqJrtcYIRwDidN29T98Ol6LK4yPFWe5zDYqqqPSZrnxfl8StP0Z9RdV7b9/nBgWXYOo57RVGatoha8Y/L2ddq9f3BLGG3YEkZPAJbvX/Y3T9vn193drcCMPDHttizLpmnCej8uZIx62GwgpqrqZPsbF0VB0CSbVJwAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": " ",
        "title": " ",
        "src": "/version/2.6.2/static/2b35e5861952ccfe088f120c5733fd22/e3189/edit-item-example.png",
        "srcSet": ["/version/2.6.2/static/2b35e5861952ccfe088f120c5733fd22/a2ead/edit-item-example.png 259w", "/version/2.6.2/static/2b35e5861952ccfe088f120c5733fd22/6b9fd/edit-item-example.png 518w", "/version/2.6.2/static/2b35e5861952ccfe088f120c5733fd22/e3189/edit-item-example.png 1035w", "/version/2.6.2/static/2b35e5861952ccfe088f120c5733fd22/44d59/edit-item-example.png 1553w", "/version/2.6.2/static/2b35e5861952ccfe088f120c5733fd22/913b9/edit-item-example.png 1822w"],
        "sizes": "(max-width: 1035px) 100vw, 1035px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
<hr></hr>
<h2>{`Sizes`}</h2>
<p>{`Modals come in three responsive sizes: small, medium, and large.`}</p>
<span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1035px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "63.70656370656371%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABsElEQVQoz2VRyU7CUBTlPwlDB2hpCy1DArSAgcDChA1GE+PGNXGl0YgkJsaVUcYasDSsNOoXkBik1EMflIJn8d677547nHt9UQccx0V3wbJsIBDw+/0Mw/z3EvjIBQbYEQegwsxkMs1m8/bmWtNUmqbxGdkAJs5VMC6e5zVNy+VyyWRSURT8hEKhWq22WFiWbTcajWAwCKosy/Bms9lKpSIIAmjryvF4XJKkmAOYFEWpqtrr90+vHrJaiaEpKEMNwQGy4L1tm3VAuvJOISHGCA9w24aoddveaXEOCK/dbvd6PV1/7bw8oymk5h24nFUw7EKhUC6XMSGimXRhmubSsn5+ren7l6LIGBJcIGA01WpVFMW1ZsRDKmmPZIXmVutuOjFaj0+H5xeyJGIZxEXI5O1zxXgXuMnFCTE+IQnePXvJPveLZEXNYrE4Ho87nY5hGBPTfDOM78+Per0eDodd2dtgGKVSKZ/Pp1Ip1MQabduezWbz+RwPy7JmS/vo+ARR6XR6XzOpSUA2PBqNBoPBcDjUdb3b7Z5d3qsHFZahOafsjuY9JRh1cBdRhopE2P/MPxmWbvunYMs5AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": " ",
        "title": " ",
        "src": "/version/2.6.2/static/e49459800081a9eebbc6caca446cd075/e3189/modal-sizes.png",
        "srcSet": ["/version/2.6.2/static/e49459800081a9eebbc6caca446cd075/a2ead/modal-sizes.png 259w", "/version/2.6.2/static/e49459800081a9eebbc6caca446cd075/6b9fd/modal-sizes.png 518w", "/version/2.6.2/static/e49459800081a9eebbc6caca446cd075/e3189/modal-sizes.png 1035w", "/version/2.6.2/static/e49459800081a9eebbc6caca446cd075/c1b63/modal-sizes.png 1200w"],
        "sizes": "(max-width: 1035px) 100vw, 1035px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
<h3>{`Small`}</h3>
<p>{`The default width of the small modal is 300px. Works well for basic alerts and confirmations.`}</p>
<DemoModal size="small" mdxType="DemoModal" />
<h3>{`Medium`}</h3>
<p>{`The default width of the medium modal is 600px. Works well for standard single-column forms.`}</p>
<DemoModal size="medium" mdxType="DemoModal" />
<h3>{`Large`}</h3>
<p>{`The default width of the large modal is 900px. Works well for UI's requiring multi-column layouts. If you are considering the large modal, you should also be seriously considering using a new page instead.`}</p>
<DemoModal size="large" mdxType="DemoModal" />
<h3>{`Modal Height`}</h3>
<p>{`React Magma modals do not have a maximum height at this time. They are as tall as they need to be to fit the content, which means it's possible for the bottom of the modal to extend beyond the bottom of the viewport. You can still easily scroll the entire modal in order to access the content off-screen.`}</p>
<h3>{`Responsive Behavior`}</h3>
<p>{`When the viewport of the device is 600px wide or below, the padding within the modal decreases from 24px to 16px. This matches the change in gutter widths on the overall page layout on smaller devices. The result allows the content of the modal to maximize the available space.`}</p>
<hr></hr>
<h2>{`Behaviors`}</h2>
<h3>{`Trigger`}</h3>
<p>{`Modals are typically triggered by a user's action rather than generated by the system. Common components used to trigger a modal include buttons, links, and icons. A modal can also be opened using a keyboard by pressing `}<inlineCode parentName="p">{`Enter`}</inlineCode>{` or `}<inlineCode parentName="p">{`Space`}</inlineCode>{`.`}</p>
<h3>{`Closing`}</h3>
<p>{`Modals should always contain a way to close them, and there are typically multiple ways for any modal. The most obvious is the Close button in the upper-right corner. Less obvious, but always present, is the ability to press `}<inlineCode parentName="p">{`Escape`}</inlineCode>{` on the keyboard or simply click outside the modal. Additionally, there is often a primary action button that triggers a process and then closes the modal when it's completed or a Cancel button that closes the modal without taking any further action.`}</p>
<h3>{`Focus`}</h3>
<p>{`When a modal is opened, the focus is automatically put on the title of the modal rather than the first actionable element. We intentionally do this to provide an optimal experience for both people using assistive technologies and those who don't.`}</p>
<span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1035px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "40.54054054054054%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA70lEQVQY031PS26DMBTMOWELEWzYsUoQd0FwJTbAKqoNahHBxhYfGzqNBY0q1NF49PwZv3mX6wuO4wRBEMdxFEV34HY7aHDfNQzD644Llud5tm0nScIH+figTz7Mah1nNS6gnnZiu21bnueu6/6afd+3LCvLMqXXz6+WcS6kBAcBip5xxgfUz54prauqQsy/5jRNx3EkhFBK67qmhPwoJW3bMsb6vu+6bpqmoijOzUg1zzNUa72+sL3BbE86Y2aYpZRN00CXZVFKHWpg/v2vsxAC4Y3t8B81HpRleW7GNQZDZvMUBVJgZvTEien8bv4G151fwt9og3AAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": " ",
        "title": " ",
        "src": "/version/2.6.2/static/a7db9cbe1578c3a0603dfe84dad10cc7/e3189/modal-focus-example.png",
        "srcSet": ["/version/2.6.2/static/a7db9cbe1578c3a0603dfe84dad10cc7/a2ead/modal-focus-example.png 259w", "/version/2.6.2/static/a7db9cbe1578c3a0603dfe84dad10cc7/6b9fd/modal-focus-example.png 518w", "/version/2.6.2/static/a7db9cbe1578c3a0603dfe84dad10cc7/e3189/modal-focus-example.png 1035w", "/version/2.6.2/static/a7db9cbe1578c3a0603dfe84dad10cc7/44d59/modal-focus-example.png 1553w", "/version/2.6.2/static/a7db9cbe1578c3a0603dfe84dad10cc7/913b9/modal-focus-example.png 1822w"],
        "sizes": "(max-width: 1035px) 100vw, 1035px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
<h3>{`Validation`}</h3>
<p>{`Always validate a user's input entries before a modal is closed. If there are any errors, an inline error alert should be displayed above the form, as well as error messages on any specific inputs that failed validation. The error messages should provide clear instructions on how to resolve the errors and complete the action.`}</p>
<span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1035px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "66.40926640926641%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB0klEQVQoz31S3U/acBT174Q3KC1Vn5agscyxB+dmkFWojpHxIhCyZW/L5GnGN/eyLNmmmSLFWuWjLWtD2/Brf/TDS5ka6sfN6c2vHyfn9N4zR5IkRVGxWIxhmHK5XCwW3z9epVIpm82SNzUHF03TkUikXq/7vq/r+ng89h8qz/OgC4JAEMQdOZlMRqPRarVqI9TrdBRZHgRQJAkg9XpKX/onK/1ux9T15ukpkUiElWu1muP7AzRSbVvDeNLHGDDyPHCCAYEyz/MPKVcqxsfPPLN6ns7wzIs2YGW1nc4Azp+/bC8xZ8+WxOX0n70GubBABvwZsvbl68n6xgVbuCrsiFsFkc2LW9xlnrssbIvZt8L6m+4me/xtPzE/TwbOb21HwTa4Uk3DDuw9NrCwbXqqvLvr9yWz07Vk2UXIRVYAOCDPmhyc0ch33VazOUumaSDXYNqWpaqq4zhuUCBlmqaiKLZtwy3GkxW2Wq0weTpteKdpmmEY8DXGGDpCCDYPTyzL8lx3YvsJMsiGfhU0p15+i4PD9uDn0V+K/L/ocMLukyFww+EQXHAHJ4uffjS+/1qkKeJ22pDteDyeSqVYloXobt6rXC4HfSfPfnjHvX61lrhJ2DXEpSMV0ej1gwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": " ",
        "title": " ",
        "src": "/version/2.6.2/static/1e7f229cfd5aa43733744c580c6bf22e/e3189/modal-validation.png",
        "srcSet": ["/version/2.6.2/static/1e7f229cfd5aa43733744c580c6bf22e/a2ead/modal-validation.png 259w", "/version/2.6.2/static/1e7f229cfd5aa43733744c580c6bf22e/6b9fd/modal-validation.png 518w", "/version/2.6.2/static/1e7f229cfd5aa43733744c580c6bf22e/e3189/modal-validation.png 1035w", "/version/2.6.2/static/1e7f229cfd5aa43733744c580c6bf22e/44d59/modal-validation.png 1553w", "/version/2.6.2/static/1e7f229cfd5aa43733744c580c6bf22e/913b9/modal-validation.png 1822w"],
        "sizes": "(max-width: 1035px) 100vw, 1035px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      